const specialCharactersPattern = /[^a-zA-Z\d-]/g;

export default specialCharactersPattern;
